import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8">
      <div className="py-6 md:py-8">
        <div className="flex items-center gap-3 flex-wrap">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 hover:scale-105 cursor-pointer"
              style={{
                backgroundColor: 'oklch(var(--background-100))',
                color: 'oklch(var(--foreground-700))',
              }}
            >
              <i className={`${cat.icon} text-lg`} style={{ color: 'oklch(var(--primary-500))' }}></i>
              {cat.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}